<!-- Confirmation dialog component -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<div class="d-flex justify-content-end mb-2">
  <button
    pButton
    type="button"
    label="Download PDF"
    icon="pi pi-download"
    [disabled]="isDownloadingPdf"
    (click)="downloadDetailsPdf()">
  </button>
</div>

<div #pdfContent>
  <div class="section-header">
    <div class="section-title">
        <span class="air-heading">TLR Details</span>
      </div>
      <div class="details-link">
        <span
          class="link-underline"
          style="text-decoration: underline; font-weight : bold;"
          (click)="goToApprovals($event)"
          >Go To Approvals</span
        >
      </div>
</div>

<div class="grid">
    <!-- Left column content -->
    <div class="col-6 flex flex-column">
        <!-- Operations section -->
        <div>
            <p-table id="StyleTable" [value]="operationsData" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Operations</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.key}}</td>
                        <td [ngClass]="item.key === 'TLR Status' ? cssClass : ''">
                            <ng-container *ngIf="item.key === 'Service' && item.value && item.value.includes(','); else normalValue">
                                <div *ngFor="let service of item.value.split(','); let i = index" 
                                     [style.margin-bottom]="i === item.value.split(',').length - 1 ? '0' : '4px'">
                                    {{service.trim()}}
                                </div>
                            </ng-container>
                            <ng-template #normalValue>{{item.value}}</ng-template>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- Operations Files section -->
        <div>
            <span class="span-text">The maximum file size is 30MB, please check file size before upload/download.</span>
            <p-table id="StyleTable" [value]="operationsFileData" class="p-m-3">
                <ng-template pTemplate="header">
                    <tr>
                        <th colspan="3" class="header-row">
                            <p-button label="Add New File" icon="pi pi-plus" (onClick)="openUploadDialog('OPERATIONS')"
                                styleClass="primary-btn"> </p-button>
                        </th>
                    </tr>
                    <tr>
                        <th>Operation File Name</th>
                        <th>User</th>
                        <th>Action</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-file let-i="rowIndex">
                    <tr>
                        <td class="link-underline" (click)="downloadFile(file)">{{file.key}}</td>
                        <td>{{file.value}}</td>
                        <td>
                            <p-button icon="pi pi-trash" (onClick)="confirmDeleteFile('OPERATIONS', file, i)"
                                [disabled]="isDeletingFile" class="p-button-danger p-button-sm">
                            </p-button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="3" class="text-center p-3">
                            No operation files uploaded
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- AIR section -->
        <div>
            <p-table id="StyleTable" [value]="AIRData" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>AIR</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.key}}</td>
                        <td>{{item.value}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- AIR Files section -->
        <div class="workorder-margin" *ngIf="hasAIRData">
            <div>
                <p-table id="StyleTable" [value]="AIRFileData" class="p-m-3">
                    <ng-template pTemplate="header">
                        <tr>
                            <th colspan="3" class="header-row">
                                <p-button label="Add New File" icon="pi pi-plus" (onClick)="openUploadDialog('AIR')"
                                    styleClass="primary-btn"> </p-button>
                            </th>
                        </tr>
                        <tr>
                            <th>AIR File Name</th>
                            <th>User</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-file let-i="rowIndex">
                        <tr>
                            <td class="link-underline" (click)="downloadFile(file)">{{file.key}}</td>
                            <td>{{file.value}}</td>
                            <td>
                                <p-button icon="pi pi-trash" (onClick)="confirmDeleteFile('AIR', file, i)"
                                    [disabled]="isDeletingFile" class="p-button-danger p-button-sm">
                                </p-button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3" class="text-center p-3">
                                No AIR files uploaded
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

        <!-- Inspections section -->
        <div>
            <p-table id="StyleTable" [value]="inspectionData" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Inspections</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.key}}</td>
                        <td>{{item.value}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- OA section -->
        <div>
            <p-table id="StyleTable" [value]="OAData" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>OA</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.key}}</td>
                        <td [ngClass]="{'tlr-status-value': item.key === 'TLR Status'}" [class]="item.class">{{item.value}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
 <!-- Permanent Repair Date Changes section need to uncomment once BE API or data is ready-->
        <div class="workorder-margin" *ngIf="permanentRepairDateChanges && permanentRepairDateChanges.length > 0">
            <p-table id="StyleTable" [value]="permanentRepairDateChanges" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th colspan="4" class="header-row">Permanent Repair Date Changes</th>
                    </tr>
                    <tr>
                        <th>Date Changed</th>
                        <th>Email</th>
                        <th>Old Date</th>
                        <th>New Date</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-change>
                    <tr>
                        <td>{{change.dateChanged}}</td>
                        <td>{{change.cai}}</td>
                        <td>{{change.oldDate}}</td>
                        <td>{{change.newDate}}</td>
                    </tr>
                    <tr>
                        <td colspan="4"><strong>Justification:</strong> {{change.justification}}</td>
                    </tr>
                </ng-template>
                
            </p-table>
        </div>
        <!-- OA Files section -->
        <div class="workorder-margin" *ngIf="hasOAData">
            <div>
                <p-table id="StyleTable" [value]="OAFileData" class="p-m-3">
                    <ng-template pTemplate="header">
                        <tr>
                            <th colspan="3" class="header-row">
                                <p-button label="Add New File" icon="pi pi-plus" (onClick)="openUploadDialog('OA')"
                                    styleClass="primary-btn"> </p-button>
                            </th>
                        </tr>
                        <tr>
                            <th>OA File Name</th>
                            <th>User</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-file let-i="rowIndex">
                        <tr>
                            <td class="link-underline" (click)="downloadFile(file)">{{file.key}}</td>
                            <td>{{file.value}}</td>
                            <td>
                                <p-button icon="pi pi-trash" (onClick)="confirmDeleteFile('OA', file, i)"
                                    [disabled]="isDeletingFile" class="p-button-danger p-button-sm">
                                </p-button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3" class="text-center p-3">
                                No OA files uploaded
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

       

        <!-- Engineering section -->
        <div>
            <p-table id="StyleTable" [value]="EngineeringData" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Engineering</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.key}}</td>
                        <td>{{item.value}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="workorder-margin" *ngIf="hasEngineeringData">
            <div>
                <p-table id="StyleTable" [value]="EngineeringFileData" class="p-m-3">
                    <ng-template pTemplate="header">
                        <tr>
                            <th colspan="3" class="header-row">
                                <p-button label="Add New File" icon="pi pi-plus" (onClick)="openUploadDialog('Engineering')"
                                    styleClass="primary-btn"> </p-button>
                            </th>
                        </tr>
                        <tr>
                            <th>Engineering File Name</th>
                            <th>User</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-file let-i="rowIndex">
                        <tr>
                            <td class="link-underline" (click)="downloadFile(file)">{{file.key}}</td>
                            <td>{{file.value}}</td>
                            <td>
                                <p-button icon="pi pi-trash" (onClick)="confirmDeleteFile('Engineering', file, i)"
                                    [disabled]="isDeletingFile" class="p-button-danger p-button-sm">
                                </p-button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3" class="text-center p-3">
                                No Engineering files uploaded
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>

    <!-- Right column content -->
    <div class="col-6 flex flex-column">
        <div>
            <p-table id="StyleTable" [value]="installationData" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Installation/ Removal Dates</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.key}}</td>
                        <td>{{item.value}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div>
            <p-table id="StyleTable" [value]="maximoData" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Maximo</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.key}}</td>
                        <td *ngIf="item.value === 'Maximo Login'" class="external-link" (click)="redirectToMaximo()">
                            {{item.value}}
                        </td>
                        <td *ngIf="item.value !== 'Maximo Login'">
                            {{item.value}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="workorder-margin">
            <p-panel header="Associated Maximo Work Orders">
                <p-table id="StyleTable" [value]="workOrders" class="custom-table">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Work Order Number</th>
                            <th>Status</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-order>
                        <tr>
                            <td>
                                <button pButton label="{{order.key}}" class="{{ order.color}}" style="width :100px"
                                    (click)="workOrderClick(order)">
                                </button>
                            </td>
                            <td>{{order.value}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-panel>
        </div>
        <div>
            <p-table id="StyleTable" [value]="KMSData" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>KMS/MOC</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.key}}</td>
                        <td *ngIf="item.value === 'KMS/MOC Login'" class="external-link" (click)="redirectToKMS()">
                            {{item.value}}
                        </td>
                        <td *ngIf="item.value !== 'KMS/MOC Login'">
                            {{item.value}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div>
            <p-table id="StyleTable" [value]="IntegrityThreats" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Integrity Threats</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.key}}</td>
                        <td>
                            {{item.value}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div>
            <p-table id="StyleTable" [value]="repumpHistory" class="custom-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th colspan="4">Repump History</th>
                    </tr>
                    <tr>
                        <th colspan="4" class="headers">Total Repumps: {{getTotalRepumps()}}</th>
                    </tr>
                    <tr>
                        <th>Tag #</th>
                        <th>Repump Date</th>
                        <th>User ID</th>
                        <th>Repump Comments</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{item.tagNumber}}</td>
                        <td>{{item.repumpDate | date:'MM-dd-yyyy hh:mm:ss aa'}}</td>
                        <td>{{item.userId}}</td>
                        <td>{{item.repumpComments}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4" class="text-center p-3">
                            No repump history data available
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<!-- Enhanced Upload Dialog -->
<p-dialog [header]="dialogTitle" [(visible)]="showDialog" [modal]="true" [closable]="false" [style]="{width:'40vw'}">
    <div class="p-m-3">
        <input type="file" (change)="onFileSelected($event)" [disabled]="isUploading" class="file-input" />
        <small class="file-size-note">Maximum file size: 30MB</small>
    </div>

    <div class="button-row">
        <!-- Show spinner when uploading -->
        <p-button label="Upload File" icon="pi pi-upload" (onClick)="uploadFile()" class="p-button-success"
            [disabled]="!selectedFile || isUploading" [loading]="isUploading">
        </p-button>
        <p-button label="Close" icon="pi pi-times" (onClick)="closeDialog()" class="p-button-secondary"
            [disabled]="isUploading">
        </p-button>
    </div>

    <!-- Display upload message with appropriate styling based on status -->
    <div *ngIf="uploadMessage" class="upload-message p-mt-3 p-p-2" [ngClass]="{
            'upload-success': uploadStatus === 'success',
            'upload-error': uploadStatus === 'error'
        }">
        <i *ngIf="uploadStatus === 'success'" class="pi pi-check-circle"></i>
        <i *ngIf="uploadStatus === 'error'" class="pi pi-exclamation-triangle"></i>
        {{uploadMessage}}
    </div>
</p-dialog>